import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";

const GroupBy = () => {
  const dispatch = useDispatch();

  const {
    groupBy,
    selectedFilters: { group_by }
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);

  return (
    <MultiSelectDropdown
      options={groupBy}
      selectedFilters={group_by}
      includeFilter={false}
      numberDisplayed={1}
      onSelectChange={(data) => dispatch(actionCreators.updateGroupBy(data))}
    />
  );
};

export default GroupBy;
